import { isBrowser, isInIframe, isInPopup } from '../utils';
import { TrackingMiddleware } from '../types';

const environmentParams: TrackingMiddleware = config => async event => {
  const conditionalParams = isBrowser()
    ? {
        in_iframe: isInIframe(),
        in_popup: isInPopup(),
      }
    : {};
  const { release } = config.get(['release']);
  event.apply({ ...conditionalParams, release, timestamp: Date.now() });
};

export default environmentParams;
